/* global ClipboardJS */

( function( $ ) {
	var $clipboardButtons = $( '[data-clipboard]' );

	$clipboardButtons.each( function( ) {
		var $this = $( this );
		var $modalParent = $this.closest( '.modal' );
		var clipboardButton;

		if ( $modalParent.length ) {
			clipboardButton = new ClipboardJS( this , {
				container: $modalParent[0]
			} );
		} else {
			clipboardButton = new ClipboardJS( this );
		}

		clipboardButton.on( 'success', function ( e ) {
			var $target = $( e.trigger );
			$target.text( $target.data( 'clipboard' ) );

			e.clearSelection();
		} );
	} );
} )( jQuery );